import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ProgressBar from './ProgressBar';

function Booking() {
    const navigate = useNavigate();
    const { state } = useLocation();

    const [bookingData, setBookingData] = useState(
        JSON.parse(sessionStorage.getItem('bookingData')) || {}
    );

    const { room, adults, children, childAges, rooms, checkInDate, checkOutDate, calculatedPrice, firstName, surname, email, phone, address, city, country, zip } = bookingData;

    const [specialRequests, setSpecialRequests] = useState(bookingData.specialRequests || '');
    const [arrivalTime, setArrivalTime] = useState(bookingData.arrivalTime || 'I do not know');
    const [termsAgreed, setTermsAgreed] = useState(false);

    useEffect(() => {
        if (state) {
            sessionStorage.setItem('bookingData', JSON.stringify(state));
            setBookingData(state);
        }
    }, [state]);

    const handleProceedCheckout = () => {
        if (!termsAgreed) {
            alert("Please agree to the Terms and Conditions to proceed.");
            return;
        }

        const bookingDataToPass = {
            ...bookingData,
            specialRequests,
            arrivalTime,
            termsAgreed
        };

        navigate('/booking/checkout', { state: bookingDataToPass });
    };

    const handleGoBack = () => {
        navigate('/booking');
    };

    return (
        <div className="container mt-4">
            {/* ProgressBar at the top */}
            <ProgressBar currentStep={2} />

            <h2 className="mb-3 text-center text-md-start">Booking Details</h2>

            <div className="card p-3 p-md-4 shadow">
                <div className="row">
                    <div className="col-md-6 mb-4 mb-md-0">
                        <p><strong>Selected Room:</strong> {room?.title}</p>
                        <p><strong>Check In:</strong> {checkInDate}</p>
                        <p><strong>Check Out:</strong> {checkOutDate}</p>
                        <p><strong>Nights:</strong> {checkOutDate && checkInDate ? Math.round((new Date(checkOutDate) - new Date(checkInDate)) / (1000 * 60 * 60 * 24)) : 'N/A'}</p>
                        <p><strong>Adults:</strong> {adults}</p>
                        <p><strong>Children:</strong> {children}</p>
                        {children > 0 && (
                            <p>
                                <strong>Children Ages:</strong> {childAges?.map((age, index) => (
                                    <span key={index}>{age} years{index < childAges.length - 1 ? ', ' : ''}</span>
                                ))}
                            </p>
                        )}
                        <p><strong>Rooms:</strong> {rooms}</p>
                        <p><strong>Total Price:</strong> ${calculatedPrice ? calculatedPrice.toFixed(2) : 'N/A'}</p>
                        <p><strong>10% SERVICE CHARGE ALREADY APPLIED</strong></p>
                        <p><strong>Amenities:</strong> Bathroom 80 sq. ft., Kitchen 80 sq. ft., Hot Water, High-Speed Internet, Refrigerator, Iron, Bedroom 300 square feet space</p>
                        <p><strong>Additional Charges:</strong> Extra charges may apply for breakfast.</p>
                    </div>

                    <div className="col-md-6">
                        <form>
                            <div className="mb-3">
                                <label className="form-label">First Name:</label>
                                <input type="text" className="form-control" required value={firstName || ''} onChange={(e) => setBookingData({ ...bookingData, firstName: e.target.value })} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Surname:</label>
                                <input type="text" className="form-control" required value={surname || ''} onChange={(e) => setBookingData({ ...bookingData, surname: e.target.value })} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Email:</label>
                                <input type="email" className="form-control" required value={email || ''} onChange={(e) => setBookingData({ ...bookingData, email: e.target.value })} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Phone:</label>
                                <input type="tel" className="form-control" value={phone || ''} onChange={(e) => setBookingData({ ...bookingData, phone: e.target.value })} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Address:</label>
                                <input type="text" className="form-control" required value={address || ''} onChange={(e) => setBookingData({ ...bookingData, address: e.target.value })} />
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-6 mb-3 mb-md-0">
                                    <label className="form-label">City:</label>
                                    <input type="text" className="form-control" required value={city || ''} onChange={(e) => setBookingData({ ...bookingData, city: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Country:</label>
                                    <input type="text" className="form-control" required value={country || ''} onChange={(e) => setBookingData({ ...bookingData, country: e.target.value })} />
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ZIP:</label>
                                <input type="text" className="form-control" required value={zip || ''} onChange={(e) => setBookingData({ ...bookingData, zip: e.target.value })} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Requests:</label>
                                <textarea className="form-control" rows="3" value={specialRequests} onChange={(e) => setSpecialRequests(e.target.value)}></textarea>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Arrival:</label>
                                <select className="form-control" value={arrivalTime} onChange={(e) => setArrivalTime(e.target.value)}>
                                    <option value="Morning (6 AM - 12 PM)">Morning (6 AM - 12 PM)</option>
                                    <option value="Afternoon (12 PM - 6 PM)">Afternoon (12 PM - 6 PM)</option>
                                    <option value="Evening (6 PM - 10 PM)">Evening (6 PM - 10 PM)</option>
                                </select>
                            </div>
                            <div className="mb-3 form-check">
                                <input type="checkbox" className="form-check-input" id="termsCheck" checked={termsAgreed} onChange={(e) => setTermsAgreed(e.target.checked)} />
                                <label className="form-check-label" htmlFor="termsCheck">I agree to the Terms and Conditions</label>
                            </div>
                            <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
                                <button type="button" className="btn btn-secondary w-100 w-md-auto" onClick={handleGoBack}>
                                    Go Back
                                </button>
                                <button type="button" className="btn btn-primary w-100 w-md-auto" onClick={handleProceedCheckout}>Proceed to Checkout</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Booking;